import {Config} from './crud/Config';
import {TimeTrackerService} from '../app/time-tracker-service.service';
import {Field} from './crud/Field';
import {ModalFields} from './modal-fields';

export class Company {
    public id;
    public name;
    public logoPath;
    public active: boolean;

    constructor() {
    }

    /**
     * @param {Company} company @Nullable or initial data
     * @returns {ModalFields}
     */
    public static toModelTemplate(company: Company) {
        console.log('convert company: ', company);
        const path = TimeTrackerService.COMPANIES;
        const idField = new Field('id', 'id', 'text', false);
        const nameField = new Field('MODEL.COMPANY.NAME', 'name', 'text', true);
        const logoField = new Field('MODEL.COMPANY.LOGO', 'logoPath', 'image', false);
        const activeField = new Field('MODEL.COMPANY.ACTIVE', 'active', 'checkbox', false);

        idField.hidden = true;
        activeField.hidden = true;

        if (company != null) {
            idField.value = company.id;
            nameField.value = company.name;
            logoField.value = company.logoPath;
            activeField.value = company.active;
        }

        const modalFields = new ModalFields(
            [idField, nameField, logoField, activeField],
            new Config(''),
            false, false, false
        );
        modalFields.firebaePath = path;
        return modalFields;
    }
}



// WEBPACK FOOTER //
// ./src/models/company.ts